type StepperStepProps = {
  children: React.ReactNode
}

export const StepperStep = (props: StepperStepProps) => <div {...props} />
